{% block sw_cms_element_config_top_finder_selectboxes %}
    <sw-tabs
        defaultItem="settings"
        class="sw-cms-el-config-top-finder-selectboxes__tabs"
    >
        <template #default="{ active }">
            <sw-tabs-item
                name="settings"
                :activeTab="active"
            >
                Settings
            </sw-tabs-item>
        </template>

        <template #content="{ active }">
            {% block sw_cms_element_config_top_finder_selectboxes_settings %}
                <sw-container v-if="active === 'settings'"
                              class="sw-cms-el-config-top-finder-selectboxes__settings"
                              columns="1fr 1fr"
                              gap="24px">

                    <sw-card title="Visibility">
                        <sw-field
                            type="switch"
                            :label="$tc('sw-cms-el-top-finder-selectboxes.config.showSearch')"
                            v-model:value="element.config.showSearch.value"
                        />

                        <sw-field
                            type="switch"
                            :label="$tc('sw-cms-el-top-finder-selectboxes.config.showBrandSelect')"
                            v-model:value="element.config.showBrandSelect.value"
                        />

                        <sw-field
                            type="switch"
                            :label="$tc('sw-cms-el-top-finder-selectboxes.config.showDeviceSelect')"
                            v-model:value="element.config.showDeviceSelect.value"
                        />
                    </sw-card>

                    <sw-card title="Mode">
                        <sw-field
                            type="select"
                            :label="$tc('sw-cms-el-top-finder-selectboxes.config.selectboxesMode')"
                            v-model="element.config.selectboxesMode.value"
                        >
                            <option value="series">Brands &#8594; Series &#8594; Devices</option>
                            <option value="types">Brands &#8594; Types &#8594; Devices</option>
                            <option value="both">Brands &#8594; Types/Series &#8594; Devices</option>
                            <option value="devices">Brands &#8594; Devices</option>
                        </sw-field>

                        <sw-field
                            type="text"
                            :label="$tc('sw-cms-el-top-finder-selectboxes.config.dropdownsColumnClass')"
                            v-model:value="element.config.dropdownsColumnClass.value"
                        >
                            <template #helpText>
                                {{ $tc('sw-cms-el-top-finder-selectboxes.config.dropdownsColumnClassHelp') }}
                            </template>
                        </sw-field>
                    </sw-card>
                </sw-container>
            {% endblock %}
        </template>
    </sw-tabs>
{% endblock %}
